
import { Card, Typography } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import "../Pages/CSS/DonnesBases.css";
import ReglementFournSoins from "./ReglementFournSoins";
import ReglementsDivers from "./ReglementsDivers";

const { Title } = Typography;

const tabListNoTitle = [
  {
    key: "1",
    label: "Fournisseurs de Soins Médicaux",
  },
  {
    key: "2",
    label: "Fournisseurs Divers",
  },

 
];

const ReglementFacture = () => {

  const [activeTabKey2, setActiveTabKey2] = useState("1");


  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };


  return (
      <div style={{ padding: 12 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "10px 20px",
            background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
            borderRadius: 10,
            boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
            marginBottom: 16,
          }}
        >
          <CreditCardOutlined style={{ fontSize: 22, color: "#fff" }} />
          <span
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "#fff",
              letterSpacing: 0.5,
            }}
          >
            Règlements Factures Fournisseurs
          </span>
        </div>
        <Card
          style={{
            width: "100%",
          }}
          tabList={tabListNoTitle}
          activeTabKey={activeTabKey2}
          onTabChange={onTab2Change}
          tabProps={{
            size: "middle",
          }}
        >
        {activeTabKey2 === "1" && <ReglementFournSoins/>}
          {activeTabKey2 === "2" && <ReglementsDivers />}
        </Card>
      </div>
  );
};

export default ReglementFacture;
